import { useCallback, useMemo, useState } from 'react';

import { CellContext } from 'core';
import { Table } from 'core/Packages';
import { IconDelete, IconDuplicate, IconEdit, IconViewOn } from 'ui/Icons';

import { EventDate, useShowCurrentCampaign } from '../../../../../../../api';
import { AddEditEventDateModal } from '../AddEditEventDate/AddEditEventDateModal';
import { DeleteEventDateModal } from '../DeleteEventDateModal';

const EventDateActions = (props: CellContext<EventDate, unknown>) => {
  const { data: event } = useShowCurrentCampaign();
  const [openModal, setOpenModal] = useState<string | undefined>(undefined);
  const [isDuplicate, setIsDuplicate] = useState(false);

  const isEventFinished = useMemo(() => {
    return event?.status === 'finished';
  }, [event]);

  const handleCloseAllModals = useCallback(() => {
    setOpenModal(undefined);
    setIsDuplicate(false);
  }, [setOpenModal, setIsDuplicate]);

  if (!event) return null;
  return (
    <>
      <Table.RowAction>
        {isEventFinished ? (
          <Table.RowAction.Option
            label="View Date"
            icon={IconViewOn}
            onClick={() => setOpenModal('edit')}
          />
        ) : (
          <>
            <Table.RowAction.Option
              label="Edit Date"
              icon={IconEdit}
              onClick={() => setOpenModal('edit')}
            />
            <Table.RowAction.Option
              label="Duplicate Date"
              icon={IconDuplicate}
              onClick={() => {
                setIsDuplicate(true);
                setOpenModal('edit');
              }}
            />
            <Table.RowAction.Option
              label="Delete Date"
              icon={IconDelete}
              destructive
              onClick={() => setOpenModal('delete')}
              visible={!isEventFinished}
            />
          </>
        )}
      </Table.RowAction>
      <DeleteEventDateModal
        causeId={event.cause_id}
        eventId={event.uuid}
        dateId={props.row.original.uuid}
        opened={openModal === 'delete'}
        onClose={handleCloseAllModals}
        onSuccess={handleCloseAllModals}
      />
      <AddEditEventDateModal
        opened={openModal === 'edit'}
        onClose={handleCloseAllModals}
        dateId={props.row.original.uuid}
        isDuplicate={isDuplicate}
        causeId={event.cause_id}
        eventId={event.uuid}
      />
    </>
  );
};

export { EventDateActions };
